// for downloading an S3 file ON DEMAND, 2 step process
// step 1: make call to backend to get fresh download URL
// step 2: programmatically download it on client side from that download URL

import { suppliosApi } from '../../js/api-service';
import invoke from 'lodash/invoke';


// wrap this in try/catch - we just throw errors when we get them 
// nothing to return from this -- it just triggers the download in browser 

// NOTE - this may not work CROSS ORIGIN - only same origin it seems?  uggh... oh well.

export default async (params) => {

    // pass in EITHER endpoint + endpointArgs --OR-- s3 fileCategory + ID
    // endpoint can be suppliosApi 'dotted.string' OR a function - response must have 'url' OR provide one in 'responseKey'
    const { endpoint, endpointArgs, fileCategory, fileId, responseKey } = params;

    // 2 step process -- get the download URL (which makes the bundle), then GET from that URL
    let downloadURL = '';
    // loadingFileBundle = true;

    if (endpoint && endpointArgs ) {
        const endpointArgsArray = Array.isArray(endpointArgs) ? endpointArgs : [endpointArgs];  // you allow passing in just a single string arg (like ID)
        console.log('endpointArgsArray', endpointArgsArray);
        try {
            let resp;
            if (typeof endpoint === 'function') {
                resp = await endpoint(...endpointArgsArray);
            } else {
                resp = await invoke(suppliosApi, endpoint, ...endpointArgsArray);
            }
            const { data } = resp;
            const endpointResponseKey = responseKey ?? 'url';  // 'url' is our default response key for endpoints
            downloadURL = data[endpointResponseKey];
        } catch (err) {
            if (err.response?.status === 403) {  // if we got 403, 
                throw err;  // just re-throw it
            } else {
                throw err;  // same here... maybe combine....
            }
        }
    } else if (fileCategory && fileId) {
        try {
            const { data } = await suppliosApi.files.getS3FileData(fileCategory, fileId);
            const s3FileResponseKey = responseKey ?? 'download_url';  // download_url is our standard one for s3 files
            downloadURL = data[s3FileResponseKey];
        } catch (error) {
            console.log('Error while fetching s3 file download URL for category and id:', fileCategory, fileId);
            throw error;  // just re-throw to caller
        }
    } else {
        throw new Error(`Must provide endpoint and endpointArgs OR fileCategory and fileId - passed args were: ${JSON.stringify(params)}`);
    }
    // that was part 1 - we should now have the download URL

    if (downloadURL) {
        // from here:  https://www.stefanjudis.com/snippets/how-trigger-file-downloads-with-javascript/
        console.log('Got file bundle download URL, will now trigger download');
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = downloadURL;  // URL.createObjectURL(file);
        //link.download = file.name;

        // It needs to be added to the DOM so it can be clicked
        document.body.appendChild(link);
        link.click();

        // To make this work on Firefox we need to wait
        // a little while before removing it.
        setTimeout(() => {
            URL.revokeObjectURL(link.href);
            link.parentNode.removeChild(link);
        }, 100);  // reference just had 0 for time
    } else {
        throw new Error('Did not get file bundle downloadURL!  Cannot download');
    }
    // loadingFileBundle = false;
}